/** @format */

import {YANDEX_CHANGE_GROUPS, YandexChangeGroup} from '../../models/scatters';

const KNOWN_GROUPS = new Set<string>(YANDEX_CHANGE_GROUPS);

const getYandexChangeGroup = (raw: string | null | undefined): YandexChangeGroup => {
  return raw && KNOWN_GROUPS.has(raw) ? (raw as YandexChangeGroup) : 'OTHER';
};

export {getYandexChangeGroup};
